import { render, staticRenderFns } from "./visaChargeShipping.vue?vue&type=template&id=69663e98&scoped=true"
import script from "./visaChargeShipping.vue?vue&type=script&lang=js"
export * from "./visaChargeShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69663e98",
  null
  
)

export default component.exports